import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import * as moment from "moment";
import { Observable } from "rxjs/Observable";

import { AppService } from "../../../../../views/services/app.service";
import { User } from "../../../../../views/services/user.model";
import { InternalLoggerService } from "../../../accmgr/services/internal-audit-logger.service";
import { InternalTestService } from "../../../accmgr/services/internaltest.service";
import { PersonRequestService } from "../../../accmgr/services/person-request-service";
import { AssignTestService } from "../../../accomsupport/service/assign-test.service";

@Component({
  templateUrl: "./unassign-test-administration.component.html",
  styleUrls: ["./unassign-test-administration.component.css"]
})
export class UnAssignTestAdminCommonComponent implements OnInit, OnDestroy {
  public studentDetails: any;
  public optedTestDates = [];
  public displayTestAdministrations: any = {};
  public confirmationMessage = "";
  public disableFlag: boolean = false;
  public count: number = 0;
  public errorMsg: string;
  public personTestByIdResponse: any;
  public userProfile: User;
  constructor(
    private appService: AppService,
    private personRequestService: PersonRequestService,
    private assignTestService: AssignTestService,
    private internalTestService: InternalTestService,
    private router: Router,
    private internalLoggerService: InternalLoggerService
  ) {}

  ngOnInit() {
    this.appService.getUserProfile().then(user => (this.userProfile = user));
    this.disableFlag = false;
    this.optedTestDates = [];
    if (sessionStorage.getItem("internalStudentDetails")) {
      this.studentDetails = JSON.parse(
        sessionStorage.getItem("internalStudentDetails")
      );
      this.buildTest();
    }
  }

  ngOnDestroy() {}

  buildTest() {
    Observable.forkJoin([
      this.personRequestService.getPersonTestById(this.studentDetails.personId)
    ]).subscribe(([personTest]) => {
      this.personTestByIdResponse = personTest;
      this.getSavedTestDates(personTest);
    });
  }

  getSavedTestDates(data) {
    const array = [];
    data.forEach(element => {
      array.push(
        new Promise((resolve, reject) => {
          Observable.forkJoin(
            this.internalTestService.getTestDateNameById(element.TEST_DATE_ID)
          ).subscribe(
            ([dates]) => {
              this.displayTestAdministrations.testDateId = element.TEST_DATE_ID;
              resolve(dates.body[0]);
            },
            err => {
              reject(err);
            }
          );
        })
      );
    });
    Promise.all(array).then(value => {
      this.testType(value);
    });
  }

  testType(data) {
    const array = [];
    data.forEach(element => {
      array.push(
        new Promise((resolve, reject) => {
          Observable.forkJoin(
            this.internalTestService.getTestNameById(element.TEST_ID)
          ).subscribe(
            ([dates]) => {
              resolve(dates.body[0]);
            },
            err => {
              reject(err);
            }
          );
        })
      );
    });
    Promise.all(array).then(value => {
      value.forEach((element, index) => {
        const PERSON_TEST_INFO = this.personTestByIdResponse.filter(function(
          a
        ) {
          return a.TEST_DATE_ID === data[index].TEST_DATE_ID;
        })[0];
        this.displayTestAdministrations = {
          testDateId: data[index].TEST_DATE_ID,
          displayTest: element.TEST_NM + "-" + data[index].TEST_DATE_NM,
          personId: this.studentDetails.personId,
          check: true,
          CERTIFIED_BY_DS: PERSON_TEST_INFO.CERTIFIED_BY_DS
            ? PERSON_TEST_INFO.CERTIFIED_BY_DS
            : "",
          UPDATED_BY_DS: PERSON_TEST_INFO.UPDATED_BY_DS,
          CREATED_BY_DS: PERSON_TEST_INFO.CREATED_BY_DS,
          CREATED_ON_DT: PERSON_TEST_INFO.CREATED_ON_DT
            ? PERSON_TEST_INFO.CREATED_ON_DT
            : "",
          UPDATED_ON_DT: PERSON_TEST_INFO.UPDATED_ON_DT
            ? PERSON_TEST_INFO.UPDATED_ON_DT
            : "",
          PERSON_TEST_TYPE: PERSON_TEST_INFO.PERSON_TEST_TYPE
            ? PERSON_TEST_INFO.PERSON_TEST_TYPE
            : "",
          CERTIFIED_ON_DT: PERSON_TEST_INFO.CERTIFIED_ON_DT
            ? PERSON_TEST_INFO.CERTIFIED_ON_DT
            : "",
          CERTIFIED_FL: PERSON_TEST_INFO.CERTIFIED_FL
            ? PERSON_TEST_INFO.CERTIFIED_FL
            : "",
          REG_ID: PERSON_TEST_INFO.REG_ID ? PERSON_TEST_INFO.REG_ID : "",
          ORDER_ID: PERSON_TEST_INFO.ORDER_ID ? PERSON_TEST_INFO.ORDER_ID : "",
          EXT_ADMIN_ID: PERSON_TEST_INFO.EXT_ADMIN_ID
            ? PERSON_TEST_INFO.EXT_ADMIN_ID
            : ""
        };
        this.optedTestDates.push(this.displayTestAdministrations);
      });
      if (this.optedTestDates.length > 1) {
        this.disableFlag = true;
      }
    });
  }

  cancelnavigate() {
    this.router.navigate(["exreqdetails"]);
  }

  onSave() {
    this.errorMsg = "";
    this.count = 0;
    this.optedTestDates.forEach(item => {
      if (item.check === false) {
        this.count += 1;
      }
    });
    if (this.optedTestDates.length === this.count) {
      this.errorMsg = "Cannot UnAssign all the TestDates";
      this.onOpenHandled("errorPopModal");
    } else if (this.count === 0) {
      if (this.optedTestDates.length === 1) {
        this.errorMsg =
          "There is only one TestDate, so you can't UnAssign TestDate";
      } else {
        this.errorMsg = "Uncheck atleast one TestDate to UnAssign TestDate";
      }
      this.onOpenHandled("errorPopModal");
    } else {
      this.onOpenHandled("confirmationModal");
    }
  }

  onOpenHandled(id) {
    this.confirmationMessage = `This will remove the test administration from the student. Are you sure?`;
    document.getElementById(id).style.display = "block";
  }

  onClickOk() {
    const array = [];
    this.optedTestDates.forEach(item => {
      if (item.check === false) {
        this.onOpenHandled("confirmationModal");
        array.push(
          new Promise((resolve, reject) => {
            Observable.forkJoin(
              this.assignTestService.unassignTestAdministration(item)
            ).subscribe(
              ([res]) => {
                resolve(res);
              },
              err => {
                reject(err);
              }
            );
          })
        );
      }
    });
    this.onCloseHandled("confirmationModal");

    const uncheckedTestDates = [];
    for (let i = 0; i < this.optedTestDates.length; i++) {
      const data = this.optedTestDates[i];
      if (data.check) {
        continue;
      }
      uncheckedTestDates.push(data);
    }

    for (let i = 0; i < uncheckedTestDates.length; i++) {
      const entry = uncheckedTestDates[i];
      const loggerModel = {
        MODULE_ID: "UNASSIGN",
        CATEGORY_ID: "UNASSIGN_TEST_ADMINISTRATION",
        COMPONENT_ID: "UNASSIGN_FUNCTIONALITY",
        CREATED_BY_DS: this.userProfile.loggedInUser,
        MESSAGE_TX: "",
        REFERENCE_ID: this.studentDetails.personId,
        SEVERITY_VAL: "",
        UPDATED_BY_DS: this.userProfile.loggedInUser,
        USER_DATA_VAL:
          "Removed " +
          entry.displayTest +
          " with the following data:" +
          "UPDATED_BY_DS : " +
          entry.UPDATED_BY_DS +
          " , " +
          "CREATED_BY_DS: " +
          entry.CREATED_BY_DS +
          " , " +
          "CREATED_ON_DT : " +
          (entry.CREATED_ON_DT !== ""
            ? moment(entry.CREATED_ON_DT).format("DD/MM/YYYY")
            : "") +
          " , " +
          "UPDATED_ON_DT : " +
          (entry.UPDATED_ON_DT !== ""
            ? moment(entry.UPDATED_ON_DT).format("DD/MM/YYYY")
            : "") +
          " , " +
          "PERSON_TEST_TYPE : " +
          entry.PERSON_TEST_TYPE +
          " , " +
          "CERTIFIED_BY_DS : " +
          entry.CERTIFIED_BY_DS +
          " , " +
          "CERTIFIED_ON_DT : " +
          (entry.CERTIFIED_ON_DT !== ""
            ? moment(entry.CERTIFIED_ON_DT).format("DD/MM/YYYY")
            : "") +
          " , " +
          "CERTIFIED_FL : " +
          entry.CERTIFIED_FL +
          " , " +
          "REG_ID : " +
          entry.REG_ID +
          " , " +
          "ORDER_ID : " +
          entry.ORDER_ID +
          " , " +
          "EXT_ADMIN_ID : " +
          entry.EXT_ADMIN_ID
      };

      this.internalLoggerService
        .updateAuditLogger(loggerModel)
        .subscribe(success => {}, err => {});
    }

    Promise.all(array).then(value => {
      this.ngOnInit();
    });
  }

  onCloseHandled(id) {
    document.getElementById(id).style.display = "";
  }
}



// WEBPACK FOOTER //
// ./client/app/internal/common/components/unassign-test-administration/unassign-test-administration.component.ts